document.addEventListener("alpine:init", () => {
    const mapPost = (post) => ({
        id: post.id,
        post_type: post.post_type,
        title: post.title,
        label: post.label,
        link_text: post.link_text,
        excerpt: post.excerpt,
        url: post.url,
        target: post.target,
        thumbnail: (post.thumbnail || '').replace(/\bauto,\s?/g, ''),
        tag: post.tag,
        price: post.price,
        price_from: post.price_from,
        publish_date: post.publish_date,
        start_date: post.start_date,
        end_date: post.end_date,
        time: post.time,
        unpublish_date: post.unpublish_date,
        blog_id: post.blog_id,
        blog_name: post.blog_name,
        blog_color: post.blog_color,
        location_name: post.location_name || '',
        location_address: post.location_address || '',
        schema: post.schema || null,
    });

    Alpine.data("loadMorePosts", (data) => ({
        posts: Array.isArray(data.initialPosts) ? data.initialPosts.map(mapPost) : [],
        paged: Array.isArray(data.initialPosts) ? 2 : 1,
        hasMore: Array.isArray(data.initialPosts) ? (data.totalPosts || 0) > data.initialPosts.length : true,
        noResults: Array.isArray(data.initialPosts) && data.initialPosts.length === 0,
        showStatic: Array.isArray(data.initialPosts) && data.initialPosts.length > 0,
        currentPost: data.currentPost || '',
        postType: data.postType || '',
        postsPerPage: data.postsPerPage || 12,
        totalPosts: data.totalPosts || 0,
        categoryFilter: 'all_categories',
        tagFilter: 'all_tags',
        searchQuery: '',
        initialCategories: data.initialCategories || '',
        initialTags: data.initialTags || '',
        isCalendar: data.isCalendar || false,
        schemaId: data.schemaId || `posts-schema-${Math.random().toString(36).slice(2)}`,
        schemaEl: null,

        async fetchPosts(reset = false) {
            if (reset) {
                this.paged = 1;
                this.posts = [];
                this.hasMore = true;
                this.noResults = false;
            }

            let formData = new FormData();
            formData.append("action", "load_more_posts");
            formData.append("paged", this.paged);
            formData.append("posts_per_page", this.postsPerPage);
            formData.append("category", this.categoryFilter);
            formData.append("tag", this.tagFilter);
            formData.append("initial_categories", this.initialCategories);
            formData.append("initial_tags", this.initialTags);
            formData.append("search", this.searchQuery);
            formData.append("is_calendar", this.isCalendar ? 1 : 0);
            formData.append("current_post", this.currentPost);

            if (!this.isCalendar) {
                formData.append("post_type", this.postType);
            }

            let response = await fetch(appAjax.ajax_url, {
                method: "POST",
                body: formData,
            });

            let data = await response.json();

            if (reset || this.totalPosts === 0) {
                this.totalPosts = data.total_posts;
            }

            if (data.posts.length === 0) {
                this.hasMore = false;
                this.noResults = this.paged === 1;
            } else {
                const existingIds = new Set(this.posts.map(post => post.id));
                data.posts = data.posts.filter(post => !existingIds.has(post.id));

                this.posts.push(...data.posts.map(mapPost));

                this.updateSchema();

                this.paged++;
                this.noResults = false;

                if (this.posts.length >= this.totalPosts) {
                    this.hasMore = false;
                }
            }
        },

        loadMore() {
            this.showStatic = false;
            this.fetchPosts();
        },

        filterPosts() {
            this.showStatic = false;
            this.fetchPosts(true);
        },

        setCategoryFilter(category) {
            this.categoryFilter = category;
            this.filterPosts();
        },

        setTagFilter(tag) {
            this.tagFilter = tag;
            this.filterPosts();
        },

        updateSchema() {
            // Ett script-element per listblock (unikt id), annars skriver flera block på samma sida över varandra.
            if (!this.schemaEl) {
                this.schemaEl = document.getElementById(this.schemaId);
            }

            if (!this.schemaEl) {
                this.schemaEl = document.createElement('script');
                this.schemaEl.type = 'application/ld+json';
                this.schemaEl.id = this.schemaId;
                document.head.appendChild(this.schemaEl);
            }

            const items = this.posts.filter(post => post.schema);

            this.schemaEl.text = JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'ItemList',
                'itemListElement': items.map((post, index) => ({
                    '@type': 'ListItem',
                    'position': index + 1,
                    'url': post.url || '',
                    'item': post.schema,
                })),
            });
        },

        init() {
            if (!Array.isArray(data.initialPosts)) {
                this.loadMore();
            } else if (this.posts.length) {
                this.updateSchema();
            }
        }
    }));
});

//# sourceMappingURL=load-more-posts.js.map
